import { iposRoutes } from "../../../routes/RoutesMap";

export const INDEX_PATH: string = iposRoutes.INDEX.createLink();
export const FMC_FLOW_PATH: string = iposRoutes.FMC_FLOW.createLink();
export const FMC_FLOW_SEARCH_PATH: string = iposRoutes.FMC_FLOW_SEARCH.createLink();
export const FMC_FLOW_PLAN_PATH: string = iposRoutes.FMC_FLOW_PLAN.createLink();
export const FMC_FLOW_OPTIONS_PATH: string = iposRoutes.FMC_FLOW_OPTIONS.createLink();
export const FMC_FLOW_SUMMARY_PATH: string = iposRoutes.FMC_FLOW_SUMMARY.createLink();
export const FMC_FLOW_FTTB_ADDRESS_PATH: string = iposRoutes.FMC_FLOW_FTTB_ADDRESS_PATH.createLink();